export const GTM_BETSLIP = 'betslip';
export const GTM_BABY_BETSLIP = 'baby-betslip';
export const GTM_EW_ENABLE = 'each-way-enabled';
export const GTM_EW_DISABLE = 'each-way-disabled';
export const GTM_STAKE = 'stake';
export const GTM_STAKE_AREA = 'stake-area';
export const GTM_BET_TYPE_INFO = 'bet-type-info';
export const GTM_STAKE_AREA_EVENT = 'SP_STAKE_AREA';
export const GTM_BET_TYPE_INFO_EVENT = 'SP_BET_TYPE_INFO';
export const GTM_EVENT_PUNCTUATION = 'punctuation';
export const GTM_EVENT_QUICK_STAKE = 'quickstake';
export const GTM_EVENT_DELETE = 'delete';
export const GTM_EVENT_CONFIRM = 'confirm';
export const GTM_EVENT_FREE_BET = 'free-bet';
export const GTM_EVENT_EXPAND = 'expand';
export const GTM_EVENT_COLLAPSE = 'collapse';
export const WS_HANDLER_COMPONENT_NAME = 'Betslip';
